import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryStandardTreeList, queryUserTreeList } from '@/api/api';
import { downloadFile, getAction, postAction } from '@/api/manage';
export default {
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      standardList: [],
      drawerVisible: false,
      userTree: [],
      reportObj: {},
      userId: [],
      tableArr: [],
      statisticState: false,
      detailState: false,
      url: {
        exportXlsUrl: '/om/day/report/exportXls'
      },
      showSubmit: true
    };
  },
  props: {},
  watch: {
    drawerVisible: function drawerVisible(value) {
      if (!value) {
        this.reportObj = {};
        this.userId = [];
        this.statisticState = false;
      }
    }
  },
  mounted: function mounted() {
    this.getStandard();
    this.getUser();
  },
  methods: {
    handleExportXls: function handleExportXls(fileName) {
      var that = this;

      if (that.reportObj.id) {
        that.queryParam.id = that.reportObj.id;
      }

      if (that.reportObj.userId) {
        that.queryParam.userId = that.reportObj.userId;
      }

      if (!fileName || typeof fileName != 'string') {
        fileName = that.pageTitle + '导出文件';
      }

      var param = _objectSpread({}, that.queryParam);

      if (that.selectedRowKeys && that.selectedRowKeys.length > 0) {
        param['selections'] = that.selectedRowKeys.join(',');
      }

      var url = that.url && that.url.exportXlsUrl ? that.url.exportXlsUrl : that.pagePath + '/exportXls';
      downloadFile(fileName + '.xls', url, param);
    },
    handleExportSummaryXls: function handleExportSummaryXls(fileName) {
      var that = this;

      if (!fileName || typeof fileName != 'string') {
        fileName = that.pageTitle + '导出文件';
      }

      var param = {
        stime: that.reportObj.time
      };

      if (that.selectedRowKeys && that.selectedRowKeys.length > 0) {
        param['selections'] = that.selectedRowKeys.join(',');
      }

      var url = '/om/day/report/summaryExportXls';
      downloadFile(fileName + '.xls', url, param);
    },
    handleExportSummaryPdf: function handleExportSummaryPdf() {
      downloadFile(this.reportObj.time + '汇总运维日报.pdf', window.domainURL + '/om/day/report/summaryExportPdf?stime=' + this.reportObj.time, {});
    },
    onToGenerate: function onToGenerate() {
      var _this = this;

      postAction('/om/day/report/generateStatistics', this.reportObj).then(function (res) {
        if (res.success) {
          _this.statisticState = true;
          _this.reportObj.statistics = res.result;
        }
      });
    },
    onToDelete: function onToDelete(item, index) {
      var _this2 = this;

      this.$confirm({
        title: '提示',
        content: '确定要删除站点' + item.siteName + '的运维日报?',
        onOk: function onOk() {
          console.log('enterS');

          _this2.tableArr.splice(index, 1);
        },
        onCancel: function onCancel() {}
      });
    },
    getUser: function getUser() {
      var _this3 = this;

      // 用户
      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this3.userTree.push(temp);
          }
        }
      });
    },
    // 获取国标数据
    getStandard: function getStandard() {
      var _this4 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          var arr = [];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  if (item1.key == 'K1_3' || item1.key == 'K1_4') {
                    item1.children.forEach(function (item2, index1) {
                      arr.push(item2);
                    });
                  }
                });
              }
            }
          });
          _this4.standardList = arr;
          console.log('this.standardList', _this4.standardList);
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this5 = this;

      this.$confirm({
        title: '提示',
        content: '确定保存并推送',
        onOk: function onOk() {
          _this5.reportObj['pushUser'] = _this5.userId.length > 0 ? _this5.userId.join(',') : '';
          postAction('/om/day/report/addPush', _this5.reportObj).then(function (res) {
            if (res.success) {
              _this5.drawerVisible = false;

              _this5.$parent.getOperationList();
            }
          });
        }
      });
    },
    onClose: function onClose() {
      console.log('res');
      this.drawerVisible = false;
    },
    filterOption: function filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};